module.exports = __webpack_public_path__ + "static/screen03-99b84b13e3042035fa927c679d54fb9e.jpg";